import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';
import { CuttingSettings, PresetSettings } from 'cloud-shared-lib';
import { Observable, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserSettingsService {
  private cuttingSettings: CuttingSettings;
  private presetSettings: PresetSettings;

  constructor(private http: HttpClient) {}

  getCuttingSettings(): Observable<CuttingSettings> {
    if (this.cuttingSettings) {
      return of(this.cuttingSettings);
    }

    return this.http.get<CuttingSettings>(ApiLinks.cuttingSettings).pipe(tap(res => (this.cuttingSettings = res)));
  }

  getPresetSettings(): Observable<PresetSettings> {
    if (this.presetSettings) {
      return of(this.presetSettings);
    }

    return this.http.get<PresetSettings>(ApiLinks.presetSettings).pipe(tap(res => (this.presetSettings = res)));
  }

  clearCuttingSettings(): void {
    this.cuttingSettings = null;
  }

  clearPresetSettings(): void {
    this.presetSettings = null;
  }

  getBannerUrl(key: string): Observable<string> {
    const httpParams: HttpParams = new HttpParams().set('key', key);

    return this.http.get<string>(ApiLinks.bannerSetting, { params: httpParams });
  }
}
